import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function Productores() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('idpropietario', 'Propietario'),
      Table.Field('nombre', 'Nombre'),
      Table.Field('comentario1', 'Comentario 1'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('productor', 'nombre', 'idproductor')
    )
  )
  
  return (
    <div>
      <h2>Productores</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
